import { render } from "./SafetyDashboard.vue?vue&type=template&id=099e0fb8&scoped=true"
import script from "./SafetyDashboard.js?vue&type=script&lang=js"
export * from "./SafetyDashboard.js?vue&type=script&lang=js"

import "./SafetyDashboard.vue?vue&type=style&index=0&id=099e0fb8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099e0fb8"]])

export default __exports__